module.exports = __webpack_public_path__ + "img/projects2-wide.f3b9bd0e.png";